<template lang="pug" src="./roles.pug"></template>
<style lang="scss" src="./roles.scss" scoped></style>

<script>
import scroll from '@/utils/scroll'

import { mapState, mapGetters } from 'vuex'

export default {
    data: () => ({
        removeId: null,
        removeDialog: false,
        filters: {
            fromDate: null,
            toDate: null,
            name: null
        },
        sorting: {}
    }),
    computed: {
        ...mapGetters(['type', 'permissions']),
        ...mapState({
            roles: state => state.roles.roles,
            pagination: state => state.roles.pagination,
            rolesList: state => state.roles.rolesList,
            isTableLoad: state => state.roles.isLoaded,
            appliedFilters: state => state.roles.filters
        }),
        headers() {
            return [
                { text: 'name', value: '"name"' },
                { text: 'adminsCount', value: '"count"' },
                { text: 'state', value: '"enabled"' },
                { text: 'actions', sortable: false }
            ].map(it => Object.assign(it, {
                text: this.$vuetify.t(`$vuetify.pages.Roles.table.${it.text}`)
            }))
        },
        buttons() {
            return [
                {
                    type: 'edit',
                    method: this.editRole
                },
                {
                    type: 'delete',
                    method: this.openRemoveDialog
                }
            ]
        }
    },
    watch: {
        sorting: {
            handler() {
                this.getRolesByPage()
            },
            deep: true
        }
    },
    created: function() {
        this.filters = Object.assign({}, this.appliedFilters)
        this.$store.dispatch('roles/getRolesList')
        this.getRolesByPage()
    },
    beforeRouteLeave: function(to, from, next) {
        this.$store.commit('roles/SET_PAGINATION', { page: 1, length: null })
        next()
    },
    methods: {
        submit() {
            this.$store.commit('roles/SET_FILTERS', Object.assign({}, this.filters))
            this.getRolesByPage()
        },
        reset() {
            this.filters = Object.assign({}, {
                fromDate: null,
                toDate: null,
                name: null
            })
            this.$store.commit('roles/RESET_ROLES_FILTERS')
            this.getRolesByPage()
        },
        getRolesByPage(page = 1, isScrollEnable = false, excel = false) {
            this.$store.dispatch('roles/getRoles', {
                page,
                column: this.sorting.sortBy,
                direction: this.sorting.descending ? 'desc' : 'asc',
                excel,
                ...this.appliedFilters
            }).then(_ => {
                if (isScrollEnable) {
                    scroll(this.$refs.table)
                }
            })
        },
        changeToDate(date) {
            this.filters.toDate = date
        },
        changeFromDate(date) {
            this.filters.fromDate = date
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getRolesByPage(page, true)
            }
        },
        openRemoveDialog(id) {
            this.removeId = id
            this.removeDialog = true
        },
        removeRole() {
            this.$store.dispatch('roles/removeRole', this.removeId).then(() => {
                this.removeDialog = false
                this.removeId = null

                this.getRolesByPage()
            })
        },
        editRole(id) {
            this.$router.push(`roles/editor/${id}`)
        },
        createRole() {
            this.$router.push('roles/editor')
        },
        exportToExcel() {
            this.getRolesByPage(1, false, true)
        }
    }
}
</script>
